import { render, staticRenderFns } from "./LandingROI.vue?vue&type=template&id=89394724&scoped=true"
import script from "./LandingROI.vue?vue&type=script&lang=js"
export * from "./LandingROI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89394724",
  null
  
)

export default component.exports